import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { HlmBtnDirective, HlmIconComponent } from '../../ui';

/**
 * Section card on `UserAccountInfoComponent` — hosts the "Generate TAN" CTA.
 *
 * The static Telefonpasswort moved into the Account Settings column (read-only
 * with audited reveal) — this section now exists purely to host the TAN action.
 */
@Component({
  selector: 'cmt-phone-authentication-section',
  standalone: true,
  imports: [HlmBtnDirective, HlmIconComponent],
  templateUrl: './phone-authentication-section.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhoneAuthenticationSectionComponent {
  readonly generateTan = output<void>();
}
